"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.resetAllLeaderboardFilters = exports.resetLeaderboardFilters = exports.setLeaderboardFilters = void 0;

var setLeaderboardFilters = function setLeaderboardFilters(leaderboardType, data) {
  return {
    type: 'OLY_SET_LEADERBOARD_FILTERS',
    payload: {
      data: data,
      leaderboardType: leaderboardType
    }
  };
};

exports.setLeaderboardFilters = setLeaderboardFilters;

var resetLeaderboardFilters = function resetLeaderboardFilters(leaderboardType) {
  return {
    type: 'OLY_RESET_LEADERBOARD_FILTERS',
    payload: {
      leaderboardType: leaderboardType
    }
  };
};

exports.resetLeaderboardFilters = resetLeaderboardFilters;

var resetAllLeaderboardFilters = function resetAllLeaderboardFilters() {
  return {
    type: 'OLY_RESET_ALL_LEADERBOARD_FILTERS'
  };
};

exports.resetAllLeaderboardFilters = resetAllLeaderboardFilters;
var _default = {
  resetLeaderboardFilters: resetLeaderboardFilters,
  setLeaderboardFilters: setLeaderboardFilters,
  resetAllLeaderboardFilters: resetAllLeaderboardFilters
};
exports["default"] = _default;
//# sourceMappingURL=actions.js.map